import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import AdvertiserDashboard from "./pages/AdvertiserDashboard";
import PublisherDashboard from "./pages/PublisherDashboard";
import SelfServeDashboard from "./pages/SelfServeDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AnalyticsPage from "./pages/AnalyticsPage";
import "./App.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/auth" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

const DashboardRouter = () => {
  const { user } = useAuth();
  
  if (!user) return <Navigate to="/auth" replace />;
  
  switch (user.role) {
    case "admin":
      return <AdminDashboard />;
    case "publisher":
      return <PublisherDashboard />;
    case "advertiser":
    default:
      return <AdvertiserDashboard />;
  }
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#09090B]">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardRouter />
              </ProtectedRoute>
            } />
            <Route path="/self-serve" element={
              <ProtectedRoute allowedRoles={["advertiser", "admin"]}>
                <SelfServeDashboard />
              </ProtectedRoute>
            } />
            <Route path="/publisher" element={
              <ProtectedRoute allowedRoles={["publisher", "admin"]}>
                <PublisherDashboard />
              </ProtectedRoute>
            } />
            <Route path="/advertiser" element={
              <ProtectedRoute allowedRoles={["advertiser", "admin"]}>
                <AdvertiserDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute allowedRoles={["advertiser", "publisher", "admin"]}>
                <AnalyticsPage />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster 
            theme="dark" 
            position="top-right"
            toastOptions={{
              style: {
                background: '#18181B',
                border: '1px solid #27272A',
                color: '#FAFAFA',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
